import ColumnLayout from '../../../../main/components/column-layout';
import { JigyoDetail } from './jigyoDetailPage.presenter';
import { SkeletonCard } from '../shared/organisms/card/skeltonCard.presenter';
import { useJigyoDetailContainer } from './jigyoDetail.container.hooks';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '@/shared/t-contents-params';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';
import setting_m_lg_configQueries from '@/main/queries/setting_m_lg_config.queries';
import { useEffect } from 'react';
import { useQuery, useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import pdca_t_pdcaQueries from '../../queries/pdca_t_pdca.queries';
import { FETCH_T_PDCA_ID } from '../../queries/pdca_t_pdca.queries.type';

// type UseJigyoDetailContainer = () => {
//     lgconfig: FETCH_M_LG_CONFIG | undefined;
// };

/**
 * 事業詳細ページコンテナコンポーネント
 * @returns
 */
export function jigyoDetailPage({ formID, params }: IContentsContentElem<TContentsContentParams>) {
    const { lgcode, jigyoYear, jigyoID }: { lgcode: string; jigyoYear: string; jigyoID: string } = useParams();

    // LG設定データ取得
    const { data: lgConfigData } = useQuery<FETCH_M_LG_CONFIG>(setting_m_lg_configQueries.FETCH_M_LG_CONFIG, {
        variables: { lgcode },
        fetchPolicy: 'cache-first',
    });

    // 事業データ取得の準備
    const [loadJigyoData, { data: jigyoData }] = useLazyQuery<FETCH_T_PDCA_ID>(pdca_t_pdcaQueries.FETCH_T_PDCA_ID, {
        fetchPolicy: 'cache-first',
        onError: (error) => console.error(error.message),
    });

    // lgConfigDataが取得できたらjigyoDataを取得
    useEffect(() => {
        if (lgConfigData?.setting_m_lg_config[0]?.created_year) {
            loadJigyoData({
                variables: {
                    lgcode,
                    createdYear: Number(lgConfigData.setting_m_lg_config[0]?.created_year) - 1, // ここでlgConfigDataのcreated_yearを利用
                    jigyoYear: Number(lgConfigData.setting_m_lg_config[0]?.created_year),
                    _id: jigyoID,
                },
            });
        }
    }, [lgConfigData, lgcode, jigyoYear, jigyoID, loadJigyoData]);

    if (jigyoData && lgConfigData) {
        return (
            <ColumnLayout>
                <JigyoDetail
                    {...{
                        formID,
                        params,
                        lgcode,
                        data: jigyoData,
                        jigyoYear,
                        lgconfig: lgConfigData,
                    }}
                />
            </ColumnLayout>
        );
    } else {
        return (
            <ColumnLayout>
                <SkeletonCard />
            </ColumnLayout>
        );
    }
}
